import { render, staticRenderFns } from "./CategoriesFilterDesktop.vue?vue&type=template&id=54772ba8&scoped=true&"
import script from "./CategoriesFilterDesktop.vue?vue&type=script&lang=js&"
export * from "./CategoriesFilterDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesFilterDesktop.vue?vue&type=style&index=0&id=54772ba8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54772ba8",
  null
  
)

export default component.exports